<div class="mr-2">
    <p-splitButton
        [disabled]="!selectionItem"
        [id]="pageCode + '_historySplitButton'"
        label="{{ 'hrHistorySplitButton.label' | translate }}" outlined severity="secondary"
        [model]="items"
        [icon]="'pi pi-history'"
    >
    </p-splitButton>
</div>
